import styled from 'styled-components';

export const Label = styled.p`
  margin: 0 0.7rem 0.7rem 0;
  color: var(--texto-color);
  letter-spacing: 0.1rem;
  font-size: var(--font-tamanho);
`;

export const ContainerEditorTexto = styled.div`
  .ck.ck-editor__main > .ck-editor__editable {
    min-height: 130px;
    padding-left: 20px;
    color: var(--texto-color);
  }
`;
